import React from "react";

import Header from '../../header';
import Footer from '../../footer';

import Photo from '../../images/ukonceni-prazdin/Konec_prazdnin.jpg';


export default class UkonceniPrazdnin extends React.Component {

    render() {
      return (<div>
              <Header />
  		        <div className="view textArticle camps">

                <div className="indent">
                  <img src={Photo} alt="J4K" />
                </div>

                <p>
                Léto a prázdniny se pomalu chýlí ke konci, ale my je jako každý rok zakončíme tak, jak to máme nejraději – na hřišti, v rukavicích, s hromadou zábavy a skvělou partou!
                </p>

                <p>
                Srdečně vás zveme na naši tradiční jednodenní akci Ukončení prázdnin 2026, kde společně vyladíme formu před startem nové sezóny.
                </p>

                <p>
                Co vás čeká?
                </p>

                <p>
                ⚽ 2 tréninkové jednotky zaměřené na brankářské dovednosti s našimi trenéry
                </p>

                <p>
                ⚽ Hromada zábavy, her a skvělé atmosféry
                </p>

                <p>
                ⚽ Den strávený v partě lidí se stejnou brankářskou diagnózou
                </p>

                <p>
                <b>Základní informace k akci: 📅</b>
                <br/>
                ⏰ Čas: 9:00 – 15:00
                </p>

                <p>
                📍 Místo:
                <br/>
                Pondělí 24.8. Dačice
                  <br/>
                Úterý 25.8. Třebíč
                  <br/>
                Středa 26.8. Pelhřimov
                  <br/>
                Čtvrtek 27.8. Žďár nad Sázavou
                  <br/>
                Pátek 28.8. Luka nad Jihlavou
                  <br/>
                Pondělí 31.8. Brno - Bohunice
                </p>

                <p>
                  💰 Cena: 1 000 Kč (v ceně je oběd, svačina i pitný režim)
                </p>

                <p>
                  Přijď si s námi užít skvělý den! Ať už s námi trénuješ pravidelně, nebo chceš mezi nás zavítat poprvé, rádi tě uvidíme.
                </p>

                <p>
                  Těšíme se na vás!
                </p>

                <p>
                  <h4> <a href='https://just4keepers.dtap.cz/register/?link=60'>Přihláška tady</a></h4>
                </p>
              </div>

              <Footer />
        </div>
      );
    }

  }
